import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { staffDutySchema } from "./enums.js";
/**
 * İstasyon personeli (`station_staff`) — kullanıcı hesabı ile personel carisi arasındaki bağ.
 *
 * · Pompacının kullanıcı hesabı OLMAYABİLİR (`userId` boş): hesabını müdür girer.
 * · `counterpartyId` verilirse cari `PERSONNEL` rolünde olmalıdır: kasa açığı oraya borç yazılır.
 * · KVKK (AGENTS.md §3.14): `fullName` kişisel veridir — yanıtta döner, denetim izine / olaya / günlüğe YAZILMAZ.
 */
export const staffCodeSchema = z
    .string()
    .trim()
    .regex(/^[A-Z0-9][A-Z0-9_.-]{0,19}$/, "Personel kodu A–Z, 0–9, nokta, tire ve alt çizgiden oluşur")
    .describe("İstasyon içinde tekil personel kodu");
export const stationStaffSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    staffCode: z.string(),
    /** KVKK: kişisel veri. */
    fullName: z.string(),
    duty: staffDutySchema,
    userId: uuidSchema.nullable(),
    counterpartyId: uuidSchema.nullable(),
    counterpartyName: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: timestampSchema,
    version: z.number().int().min(1),
});
export const createStationStaffSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema,
    staffCode: staffCodeSchema,
    fullName: z.string().trim().min(2).max(120).describe("KVKK: kişisel veri"),
    duty: staffDutySchema,
    userId: uuidSchema.nullable().default(null).describe("Kullanıcı hesabı varsa bağlanır"),
    counterpartyId: uuidSchema.nullable().default(null).describe("Personel carisi (rol PERSONNEL)"),
});
/** Kısmi güncelleme: gönderilmeyen alan değişmez (`common/patch.test.ts` bunu doğrular). */
export const updateStationStaffSchema = z.object({
    staffCode: staffCodeSchema.optional(),
    fullName: z.string().trim().min(2).max(120).optional(),
    duty: staffDutySchema.optional(),
    userId: uuidSchema.nullable().optional(),
    counterpartyId: uuidSchema.nullable().optional(),
    isActive: z.boolean().optional().describe("false → pasifleştirir (fiziksel silme yok)"),
    version: z.number().int().min(1),
});
export const listStationStaffQuerySchema = pageQuerySchema.extend({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    duty: staffDutySchema.optional(),
    isActive: z
        .enum(["true", "false"])
        .optional()
        .transform((value) => (value === undefined ? undefined : value === "true")),
});
export const stationStaffPageSchema = pageOf(stationStaffSchema);
export const staffParamsSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=staff.js.map